import { MutableRefObject, useEffect } from "react"
import { Grid, TextField, Button, Autocomplete, Alert } from "@mui/material"
import { useAxios } from "../../../hooks/useAxios"
import { useServiceForm } from "./useServiceForm"
import { useLookupTables } from "../../../hooks/useLookupTables"
import PreLoader from "../../PreLoader"
import { Service } from "../types"
import { SaveAlt } from "@mui/icons-material"
import { AxiosRequestConfig } from "axios"
import { useServicesService } from "./useServiceServices"

type AutomatedServiceFormProps = {
  id?: number
  handleUpdateOrCreate: (method: "PUT" | "POST", url: string, data: any, config?: AxiosRequestConfig) => Promise<void>
  isHandlingUpdateOrCreate: boolean
  originalTriggers: MutableRefObject<number[]>
}

const API_URL = process.env.REACT_APP_NOTIFIER_URL

export default function ServiceForm({ handleUpdateOrCreate, isHandlingUpdateOrCreate, id, originalTriggers }: AutomatedServiceFormProps) {
  const {
    lookupTables,
    isLoadingLookupTables,
    errorLookupTables,
  } = useLookupTables(['triggers'])

  const {
    data: service,
    isLoading,
    error
  } = useAxios<Service>(id ? `${process.env.REACT_APP_NOTIFIER_URL}/automated-services/${id}` : '')

  const {
    currentValues,
    isFormSubmittable,
    setForm
  } = useServiceForm(service)

  const { preparePayload } = useServicesService()

  useEffect(() => {
    if (service) {
      originalTriggers.current = service.triggers.map((item) => item.id)
    }
  }, [service, originalTriggers])

  if (isLoadingLookupTables || isLoading) return <PreLoader />

  if (errorLookupTables || !lookupTables || error) return <Alert severity="error">Error while loading page.</Alert>

  return <Grid container>
    <Grid item xs={6}>
      <TextField
        id='form-field-service-name'
        label='Service Name'
        value={currentValues.automated_service_name}
        onChange={(e) => setForm((prev) => ({ ...prev, automated_service_name: e.target.value }))}
      />
    </Grid>

    <Grid item xs={6}>
      <TextField
        id='form-field-path'
        label='Path'
        value={currentValues.path}
        onChange={(e) => setForm((prev) => ({ ...prev, path: e.target.value }))}
      />
    </Grid>

    <Grid item xs={12}>
      <Autocomplete
        id='form-field-trigger'
        multiple
        disableCloseOnSelect
        options={lookupTables.triggers}
        value={currentValues.triggers}
        onChange={(e, newValue) => setForm((prev) => ({ ...prev, triggers: newValue }))}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderInput={(params) => <TextField {...params} label='Triggers' />}
      />
    </Grid>

    <Grid item xs={3}>
      <Button
        id='button-new-service'
        startIcon={<SaveAlt />}
        sx={{ height: 56 }}
        disabled={isHandlingUpdateOrCreate || !isFormSubmittable}
        onClick={id ? () => handleUpdateOrCreate('PUT', `${API_URL}/automated-services/${id}`, preparePayload(currentValues, id)) : () => handleUpdateOrCreate('POST', `${API_URL}/automated-services`, preparePayload(currentValues))}>
        Save
      </Button>
    </Grid>
    <Grid item xs={12}></Grid>
  </Grid >
}
